import React from "react"
import { Link } from "gatsby"

import Layout from "../../../components/layout"
import { FooterAlternate1 } from "../../../components/footer"
import SEO from "../../../components/seo"

const IndexPage = () => (
    <Layout>
      <SEO title="Saying NO to customers - is very powerful" />

                    
<nav className="share-bar">
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/&amp;title=Saying%20NO%20to%20customers%20-%20is%20very%20powerful&amp;summary=Saying%20NO%20to%20customers%20-%20is%20very%20powerful&amp;source=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-linkedin-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Saying%20NO%20to%20customers%20-%20is%20very%20powerful&amp;url=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon">
                    <svg width="23" height="23">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-twitter-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon">
                    <svg width="26" height="26">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-googleplus-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon">
                    <svg width="22" height="22">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-facebook-badge"></use>
                    </svg>
                </span>
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Saying%20NO%20to%20customers%20-%20is%20very%20powerful&amp;body=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon">
                    <svg width="20" height="20">
                        <use href="../../../static/images/svg/symbol-defs.svg#social-email-badge"></use>
                    </svg>
                </span>
            </Link>
        </li>
    </ul>
</nav>

<article className="article">

    

<header className="header header--article article__header" id="page-header">
    <div className="header__image" >
        <div className="header__bgimage" style={{backgroundImage: "url(../../../media/images/article-search-fishing.2e16d0ba.fill-1162x655.jpg)"}}></div>
        <div className="header__video">
            <div className="embed-responsive embed-responsive-16by9"></div>
        </div>
    </div>
    <div className="header__content">
        <div className="container">
            <div className="row">
                <div className="header__inner col-md-7 col-lg-offset-1">
                    <Link to="knowledge-centre/insights/" className="header__back back-link">
                        <span className="sr-only">Back to all articles</span>
                        <i className="icon"></i>
                    </Link>
                    <div className="header__title">
                        <h3>B2B Sales</h3>
                        <h1>Saying NO to customers - is very powerful</h1>
                    </div>
                    <ul className="post-meta-list">
                        <li>by Graham Hawkins</li>
                        <li>9 March 2016</li>
                        <li>4 min read</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</header>


<div className="container" id="article-content">
    <div className="row">
        <div className="article__body col-sm-12 col-md-8 col-lg-offset-1 col-lg-7 wysiwyg">
            
<h3>Building pipeline coverage is a mistake….’qualifying out’ is what increases productivity.</h3>

<div className="rich-text"><p>Since the earliest incarnations of B2B sales models (dating back to the 1880’s), sales people have been trained constantly on the importance of <em>qualifying</em> the prospective customer to ensure complete and full understanding of the customer needs or <em>pain points</em>. Success and failure in sales nearly always hinges on the sales person’s ability to sift out the <em>tyre kickers</em> from the genuine buyers narrowing the focus, and increasing the chances of conversion. However, most of the generally accepted practices around sales qualifying that I have used throughout my career are now increasingly out of step with the modern <em>buying journey</em>. </p><p>In today’s business context of mature markets, educated customers and high levels of (global) competition, where the vast majority of buyers are now aiming to reduce the number of vendors they engage with, effective sales people are now required to become much more strategic and selective about where, and in what quantity, they commit company resource to pursuing new business opportunities. Being called into a sales opportunity <em>late</em> nearly always suggests that you are simply being used as ‘<em>column fodder’.</em><br/></p></div>
<img alt="Column Fodder" className="img-responsive" height="444" src="../../../media/images/AAEAAQAAAAAAAAamAAAAJDdhOTk4YmNiLTY4ZTYtNGE5OS.width-647.png" width="647"/>

<div className="rich-text"><h3><b>‘Qualifying Out’ should now be the priority:</b></h3><p>Walking away from a potential sales opportunity is a difficult thing for most sales people to do because sales people are by their very nature highly optimistic animals (wishful thinkers)…always believing that they can win the deal. <em>Qualifying out</em> also runs counter to the conventional (and now outdated) wisdom that emphasises building ‘pipeline coverage’ as the number one priority. This stems from the old <em>“sales is a numbers game”</em> logic that no longer holds true. Old school sales people that continue to manage their territories through the lens of the proverbial rose coloured glasses are a real danger to most businesses. If any other business department gambled company resource so recklessly there would be consequences, and yet unwitting sales people can cost their companies significant sums of money when they fail to properly qualify the aforementioned <em>‘column fodder’</em> scenarios.</p><p>To address this issues, in my last role, my team and I implemented a very simple system that rapidly translated to an important increase in our ‘conversation ratio’. In short, we conducted some detailed analysis into our historical sales data, and we questioned some of the long held beliefs and metrics around pipeline management. Through some careful analysis we quickly learned that out of every 10 live opportunities that had progressed to “proposal stage” (60% probability) we were converting, on average, 3 of these 10 into closed sales resulting in revenue for the business. That is, 30% conversion or <em>win</em>rate from “proposal stage” which is actually high, but then we were the market leader in our space at that time. In search of an uplift in conversion, we then decided to trial a new approach that would mean each sales person would have to become even more uncompromising and almost brutal about the way that they were qualifying opportunities which in many cases meant <em>qualifying out</em> from any sales opportunities where we believed that we were being used as <em>‘column fodder’</em>. We began approaching <em>qualifying</em> from the opposite direction – by providing small incentives (or rewards/spiffs) to sales people to ‘<em>qualify out’</em> of an opportunity rather than clinging desperately to a ‘stuck’ sale that in reality was never going to close. This pipeline cleansing can be scary for most sales leaders because we are all taught that you must have at least 2-5 times quota in your pipeline to be successful, and this is really yet another anachronism that in my opinion, has no place in modern sales planning.</p><p>Allow let me explain why: as mentioned earlier, my team and I had a conversion rate of circa 30% meaning that out of every 10 opportunities that had progressed through to Sales Stage 5 (Proposal) in our Forecast, we were converting only 3. By taking the focus away from pipeline coverage, and by implementing some increased rigor around ‘qualifying out’ we were able to change some entrenched behaviour’s and reduce the 10 opportunities in Proposal Stage down to 7 whilst still converting 3 as closed sales. In other words, we began focusing on ‘qualifying out’ of any opportunities that were ‘stuck deals’ or where we believed that we were being used as ‘column fodder’. The result here was that instead of closing 3 out of 10 opportunities we were now in effect closing 3 out of 7. This translated into an instant increase from 30% to 42% in conversion rate, not to mention the HUGE <em>opportunity cost</em> that we had just removed. This uplift in conversion rate, and clearer focus on <em>qualifying</em> in general created a significant productivity improvement which flowed through to our bottom-line, and the truth is that this was a simple and easy to implement transformation that provided our business with a quick win.<br/></p><p>Of course, ‘qualifying out’ is also a great opportunity to test how your prospective customer views you as a potential supplier. The ancillary benefit being that customers will often respect you more for being an astute business professional when you politely explain why you are not bidding, and I have personally been involved in numerous scenarios where a customer has come back (cap in hand) to the vendor that withdraws their bid. Try it with those stuck deals, and redirect your resources onto deals that can actually be converted – you might be surprised what happens.</p><p>Narrowing your focus (and company resources) on deals that you CAN actually win is increasingly critical to future business success. </p></div>


        </div>
            
        <aside className="article__sidebar col-sm-12 col-md-4 col-lg-offset-1 col-lg-3">
            <div className="article__sidebar-wrap" id="article-sidebar">
                <div className="card card--profile">
                        
<div className="card__header">
    <div className="card__image">
        <img alt="Mentor Thumb Graham Hawkins" className="img-responsive" height="165" src="../../../media/images/Mentor-Thumb-Graham-Hawkins.2e16d0ba.fill-165x165.jpg" width="165"/>
    </div>
    <div className="card__title">
        <h4>Graham Hawkins</h4>
        <p>SalesTribe Mentor</p>
        <Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-md hidden-lg">View full profile</Link>
    </div>
</div>
<div className="rich-text"><p>With more than twenty-eight years of business experience in
executive B2B sales and sales leadership roles, Graham is a highly experienced
and versatile business executive with proven strengths in strategic business
development, go-to-market planning and sales and marketing.</p><p><br/></p><p><br/></p></div>
<Link to="solutions/find-a-mentor/graham-hawkins" className="btn btn-link hidden-xs hidden-sm">View full profile</Link>

                </div>
                <nav className="social-nav">
    <h4>Share</h4>
    <ul>
        <li className="linkedin">
            <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/&amp;title=Saying%20NO%20to%20customers%20-%20is%20very%20powerful&amp;summary=Saying%20NO%20to%20customers%20-%20is%20very%20powerful&amp;source=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">LinkedIn</span>
                <span className="icon icon-linkedin"></span>
                
            </a>
        </li>
        <li className="twitter">
            <a href="https://twitter.com/intent/tweet/?text=Saying%20NO%20to%20customers%20-%20is%20very%20powerful&amp;url=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Twitter</span>
                <span className="icon icon-twitter"></span>
                
            </a>
        </li>
        <li className="googleplus">
            <a href="https://plus.google.com/share?url=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Google+</span>
                <span className="icon icon-google-plus"></span>
                
            </a>
        </li>
        <li className="facebook">
            <a href="https://facebook.com/sharer/sharer.php?u=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Facebook</span>
                <span className="icon icon-facebook-f"></span>
                
            </a>
        </li>
        <li className="email">
            <Link to="knowledge-centre/insights/mailto:?subject=Saying%20NO%20to%20customers%20-%20is%20very%20powerful&amp;body=https%3A//salestribe.com/knowledge-centre/insights/saying-no-customers-very-powerful/" target="_blank" rel="noopener noreferrer">
                <span className="sr-only">Email</span>
                <span className="icon icon-envelope"></span>
                
            </Link>
        </li>
    </ul>
</nav>

            </div>
        </aside>
            
    </div>
</div>
</article>

<div className="block block--grey related-items">
    <div className="related-items__wrap">
        <div className="container">
            <div className="row" data-tablet-slick>
                
        <article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-complete-waste-money-and-time-part-2" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">5 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>Sales Training’ is a waste of money and time (Part 2)</strong></h3>
                    </header>
                    <p>We must stop teaching sales people how to ‘push’ buyers, and instead start training and coaching them on how to become highly specialised teachers.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/sales-training-waste-time-and-money-part-1" className="card card--article">
                <div className="card__thumb">
                    <img alt="article-connect-coffee-chat.jpg" className="card__image" height="404" src="../../../media/images/article-connect-coffee-chat_xr8wJT.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">4 min read</span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>‘Sales Training’ is a waste of time and money (Part 1)</strong></h3>
                    </header>
                    <p>When you teach sales people how to ‘push’ buyers through a sales playbook you are teaching them how to destroy your business reputation.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article><article className="related-items__item col-sm-6 col-md-4">
            <Link to="knowledge-centre/insights/b2b-sales-has-changed-about-180-degrees" className="card card--article">
                <div className="card__thumb">
                    <img alt="Mentor Large Graham Hawkins" className="card__image" height="404" src="../../../media/images/Mentor-Large-Graham-Hawkins.2e16d0ba.fill-716x404.jpg" width="716"/>
                    <span className="card__image-meta">04:28</span>
                    <span className="card__icon play-icon">
                        <i className="icon"></i>
                    </span>
                </div>
                <div className="card__inner">
                    <header>
                        <p className="card__category">B2B Sales</p>
                        <h3 className="card__title"><strong>B2B Sales has changed about 180 Degrees!</strong></h3>
                    </header>
                    <p>B2B sales has now changed so dramatically that it&#39;s a &quot;profession&quot; that is barely recognisable to the role that both Tony Hughes and Graham Hawkins began about 30 years ago - respectively.</p>
                    <footer><p className="card__author">Graham Hawkins</p></footer>
                </div>
            </Link>
        </article>

            </div>
            <div className="load-more">
                <Link to="knowledge-centre/insights/" className="btn btn-link">Browse more insights</Link>
            </div>
        </div>
    </div>
</div>

      
      <FooterAlternate1 />

    </Layout>
)

export default IndexPage 